module.exports = __webpack_public_path__ + "static/media/16UNODC35.8b019cb6.jpg";